import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export const Loader = ({loading, fixedOverlay, inlineOverlay, centered, delay}) => {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        let timeout;

        if (!loading) {
            setIsLoading(loading);
        } else {
            timeout = setTimeout(() => setIsLoading(loading), delay);
        }

        return () => clearTimeout(timeout);
    }, [loading]);


    return (isLoading ? (
        <div className={classNames(
            'gx-loader-overlay',
            {'gx-loader-overlay--fixed': fixedOverlay,
            'gx-loader-overlay--inline': inlineOverlay})}>
            <div className={classNames('gx-loader', {'gx-loader--centered': centered})} />
        </div>
    ) : null);
};

Loader.propTypes = {
    loading: PropTypes.bool,
    fixedOverlay: PropTypes.bool,
    inlineOverlay: PropTypes.bool,
    centered: PropTypes.bool,
    delay: PropTypes.number
};

Loader.defaultProps = {
    fixedOverlay: true,
    inlineOverlay: false,
    centered: true,
    delay: 350,
};
